import script from "./Ip.vue?vue&type=script&setup=true&lang=js"
export * from "./Ip.vue?vue&type=script&setup=true&lang=js"

import "./Ip.vue?vue&type=style&index=0&id=783e0a4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783e0a4f"]])

export default __exports__